// extracted by mini-css-extract-plugin
export default {"success":"Success_success__1AMkA","extra":"Success_extra__B4F0Z"};